module.exports = __webpack_public_path__ + "img/star-half-wide.dcfd45f1.svg";